export const langTypes = {
    ZH_TW: 'zh-TW',
    ZH_CN: 'zh-CN',
    ZH_HK: 'zh-HK',
    EN_US: 'en-US',
    JA_JP: 'ja',
    PT_BR: 'pt-BR',
    ES_419: 'es-419'
};

export const fromLangOptions = {
    [langTypes.ZH_TW]: 'formSetting.language_traditional_chinese',
    [langTypes.ZH_CN]: 'formSetting.language_simplified_chinese',
    [langTypes.EN_US]: 'formSetting.language_english',
    [langTypes.JA_JP]: 'formSetting.language_japanese',
    [langTypes.PT_BR]: 'formSetting.language_portuguese',
    [langTypes.ES_419]: 'formSetting.language_spanish'
};
